var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.type,"size":_vm.size,"icon":_vm.icon,"loading":_vm.loading,"disabled":_vm.disabled,"round":_vm.round},on:{"click":_vm.handleClick}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }